import { Routes } from '@angular/router';
import { SidebarLayoutComponent } from '@ui/layouts/sidebar-layout/sidebar-layout.component';
import { ConditionsPageComponent } from '@ui/pages/conditions-page/conditions-page.component';
import { IntroPageComponent } from '@ui/pages/intro-page/intro-page.component';
import { TableOfContentsComponent } from '@ui/sidebars/table-of-contents/table-of-contents.component';
import { NotFoundPageComponent } from '@ui/pages/not-found-page/not-found-page.component';
import { conditionResolver } from '@core/resolvers/condition.resolver';
import { ADMIN_ROUTES } from './admin/admin.routes';
import { entryExistsGuard } from '@core/guards/entry-exists.guard';
import { wildcard404RedirectGuard } from '@core/guards/wildcard-404-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    component: SidebarLayoutComponent,
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: IntroPageComponent,
            title: 'Medical School & USMLE Step 1 Study Resource | Doctogenic',
            data: {
              seoTitle:
                'Medical School & USMLE Step 1 Study Resource | Doctogenic',
              seoDescription:
                'Doctogenic is an online study resource for medical students with content for medical school courses and USMLE Step 1.',
            },
          },
          {
            path: '',
            component: TableOfContentsComponent,
            outlet: 'sidebar',
          },
        ],
      },

      {
        path: 'entries/:module/:slug',
        canActivate: [entryExistsGuard],
        resolve: { condition: conditionResolver },
        children: [
          { path: '', component: ConditionsPageComponent },
          { path: '', component: TableOfContentsComponent, outlet: 'sidebar' },
        ],
      },

      {
        path: '404',
        component: NotFoundPageComponent,
        title: 'Page not found | Doctogenic',
        children: [
          { path: '', component: NotFoundPageComponent },
          { path: '', component: TableOfContentsComponent, outlet: 'sidebar' },
        ],
        data: {
          seoTitle: 'Page not found | Doctogenic',
          seoDescription:
            'Doctogenic is an online study resource for medical students with content for medical school courses and USMLE Step 1.',
        },
      },

      {
        path: '**',
        canActivate: [wildcard404RedirectGuard],
        // never shown (guard redirects), but keeps the route valid
        component: NotFoundPageComponent,
      },
    ],
  },

  ...ADMIN_ROUTES,
];
